export default "<div class=\"chip chip-outline btn-outline-primary\">\n    {{label}}\n    <i class=\"close mdi mdi-close\" (click)=\"close()\"></i>\n</div>\n";